// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ImportCreateJobSchema } from './v1/import/createJobSchema';
import { v1JobSchema } from './v1/jobSchema';

export const createImportJobPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("AppUser id"),
});

export const createImportJobHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Import job created
 */
export const createImportJob201Schema = z.lazy(() => v1JobSchema);

export const createImportJobMutationRequestSchema = z.lazy(() => v1ImportCreateJobSchema);

export const createImportJobMutationResponseSchema = z.lazy(() => createImportJob201Schema);
